<template>
    <div class="wrapper" :style="{ width: device.width + 'px', height: device.height + 'px'}">
        <navigator></navigator>
        <router-view/>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import resizeWindow from './mixin/resizeWin';
    import Navigator from './components/navigator';

    export default {
        name: 'Container',
        components: {
            Navigator
        },
        mixins: [resizeWindow],
        computed: {
            ...mapState({
                device: state => state.app.device
            })
        }
    }
</script>